import { createFileRoute } from '@tanstack/react-router';

import { RewriteListEditorPage } from '../features/supply/lists/components/RewriteListEditorPage/RewriteListEditorPage';

export const Route = createFileRoute('/supply/lists_/rewrite_/edit/$listId')({
  component: RewriteEditRoute,
});

function RewriteEditRoute() {
  const { listId } = Route.useParams();
  return <RewriteListEditorPage listId={listId} />;
}
